<template>
  <table class="unstriped hover boss-table">
    <thead>
      <tr>
        <th class="boss-table-head-center">
          企業ID
        </th>
        <th class="boss-table-head-center">
          企業名
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="isEmptyCompany">
        <td
          colspan="3"
          data-test="company-no-data"
        >
          ※掲載前確認中の企業情報はありません
        </td>
      </tr>
      <tr v-else>
        <td
          class="boss-table-data"
          data-test="company-id"
        >
          {{ company.id }}
        </td>
        <td
          class="boss-table-data"
          data-test="company-name"
        >
          {{ company.name }}
        </td>
        <td class="boss-table-data">
          <button
            class="boss-button pega-width-5-5rem"
            data-test="company-preview-button"
            @click="windowOpenPreview"
          >
            企業情報
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    company: {
      type: Object,
      default: null
    }
  },
  computed: {
    isEmptyCompany () {
      return _.isEmpty(this.company)
    }
  },
  methods: {
    windowOpenPreview () {
      const routeData = this.$router.resolve({ name: 'companyPrePublishedPreview', params: { id: this.company.id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
